/* VALENESS — Frontend-Verhalten. Bewusst klein gehalten: kein Framework,
   nichts blockiert das Rendering. */
(function () {
  'use strict';

  /* ---- Mobiles Menü ---- */
  var menue = document.getElementById('mobilmenue');
  if (menue) {
    document.querySelectorAll('[data-menue-auf]').forEach(function (b) {
      b.addEventListener('click', function () { menue.showModal(); });
    });
    document.querySelectorAll('[data-menue-zu]').forEach(function (b) {
      b.addEventListener('click', function () { menue.close(); });
    });
    menue.addEventListener('click', function (e) {
      if (e.target === menue) menue.close();
    });
  }

  /* ---- Produktgalerie: Miniaturen und Blätterpfeile ----
     Beide Bedienwege gehen durch dieselbe Funktion, damit der angezeigte Stand und die
     Markierung unter den Miniaturen nicht auseinanderlaufen können. Die Pfeile laufen um:
     hinter dem letzten Bild kommt wieder das erste. */
  document.querySelectorAll('[data-galerie]').forEach(function (galerie) {
    var bilder = Array.prototype.slice.call(galerie.querySelectorAll('[data-gross]'));
    var minis = Array.prototype.slice.call(galerie.querySelectorAll('[data-mini]'));
    if (!bilder.length) return;

    var zeige = function (i) {
      /* Modulo mit Korrektur: In JS ist -1 % 5 gleich -1, nicht 4. */
      var ziel = ((i % bilder.length) + bilder.length) % bilder.length;
      bilder.forEach(function (b) {
        var sichtbar = Number(b.dataset.gross) === ziel;
        b.hidden = !sichtbar;
        /* Ein Video, von dem weggeblättert wird, läuft sonst unsichtbar weiter. */
        if (!sichtbar) {
          var v = b.tagName === 'VIDEO' ? b : b.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      minis.forEach(function (k) {
        k.setAttribute('aria-current', Number(k.dataset.mini) === ziel ? 'true' : 'false');
      });
    };

    var aktuell = function () {
      for (var i = 0; i < bilder.length; i++) {
        if (!bilder[i].hidden) return Number(bilder[i].dataset.gross);
      }
      return 0;
    };

    minis.forEach(function (knopf) {
      knopf.addEventListener('click', function () { zeige(Number(knopf.dataset.mini)); });
    });

    galerie.querySelectorAll('[data-blaettern]').forEach(function (knopf) {
      knopf.addEventListener('click', function (e) {
        /* Das Bild darunter öffnet sonst zusätzlich die Lupe. */
        e.stopPropagation();
        zeige(aktuell() + Number(knopf.dataset.blaettern));
      });
    });

    /* Pfeiltasten, solange der Fokus in der Galerie steht. */
    galerie.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      zeige(aktuell() + (e.key === 'ArrowRight' ? 1 : -1));
    });
  });

  /* ---- Newsletter-Popup ----
     Fünf Sekunden nach dem Laden, auf jedem Gerät gleich. Wer den Cookie-Hinweis noch offen
     hat, bekommt es erst danach — zwei Fenster übereinander will niemand. Geschlossen heißt
     30 Tage Ruhe, angemeldet heißt dauerhaft Ruhe. */
  var popup = document.getElementById('popup');
  if (popup && window.localStorage) {
    var SCHLUESSEL = 'valeness-popup';
    var PAUSE_TAGE = 30;

    var merken = function (wert) {
      try { localStorage.setItem(SCHLUESSEL, wert + ':' + Date.now()); } catch (e) {}
    };
    var darfZeigen = function () {
      var gemerkt;
      try { gemerkt = localStorage.getItem(SCHLUESSEL); } catch (e) { return true; }
      if (!gemerkt) return true;
      var teile = gemerkt.split(':');
      if (teile[0] === 'angemeldet') return false;
      var alter = Date.now() - parseInt(teile[1], 10);
      return !(alter > 0 && alter < PAUSE_TAGE * 86400000);
    };

    popup.querySelectorAll('[data-popup-zu]').forEach(function (b) {
      b.addEventListener('click', function () { popup.close(); });
    });
    popup.addEventListener('close', function () {
      if (!popup.dataset.erfolg) merken('geschlossen');
    });
    popup.addEventListener('click', function (e) { if (e.target === popup) popup.close(); });

    var erfolg = popup.querySelector('.hinweis-ok');
    if (erfolg) {
      /* Nach dem Absenden lädt Shopify die Seite neu — dann das Popup mit der
         Bestätigung sofort wieder zeigen und künftig nicht mehr. */
      popup.dataset.erfolg = '1';
      merken('angemeldet');
      popup.showModal();
    } else if (darfZeigen()) {
      var hinweisOffen = function () {
        var h = document.getElementById('CybotCookiebotDialog');
        return h && getComputedStyle(h).display !== 'none' && h.offsetHeight > 0;
      };
      /* Fruehestens nach fuenf Sekunden — aber nie ueber dem Cookie-Hinweis. Cookiebot
         laedt seinen Dialog nach, beim Skriptstart steht er noch nicht im Dokument.
         Eine einmalige Pruefung ginge deshalb bei jedem Erstbesucher daneben: Das Popup
         legte sich ueber den Einwilligungsdialog. Also vor jedem Oeffnungsversuch erneut
         nachsehen und sonst weiter warten. Bleibt die Sicht 90 Sekunden verstellt, wird
         gar nichts gezeigt. */
      var frist = Date.now() + 90000;
      var versuchen = function () {
        if (Date.now() > frist) return;
        /* Der Produktberater ist kein <dialog>, sondern eine eingeblendete
           Flaeche — er wuerde von der Pruefung sonst uebersehen. Wer gerade
           eine Frage tippt, darf nicht von der Rabattwerbung ueberdeckt
           werden; auf dem Handy verdeckt sie das Gespraech vollstaendig. */
        if (hinweisOffen() || document.querySelector('dialog[open]')
            || document.querySelector('#vchat:not([hidden])')) {
          setTimeout(versuchen, 700);
          return;
        }
        popup.showModal();
      };
      setTimeout(versuchen, 5000);
    }
  }

  /* ---- Lupe: Produktbild in Großansicht ----
     Öffnet das gerade sichtbare Bild bildschirmfüllend. Ein Klick im Dialog schaltet
     zwischen eingepasst und doppelter Größe um; im vergrößerten Zustand lässt sich das
     Bild scrollen. 3D-Modelle und Videos bleiben außen vor — die haben eigene Bedienung. */
  var lupe = document.getElementById('lupe');
  if (lupe) {
    var lupeBild = lupe.querySelector('[data-lupe-bild]');
    var buehne = lupe.querySelector('[data-lupe-buehne]');

    var sichtbaresBild = function () {
      var alle = document.querySelectorAll('.galerie__gross img[data-gross]');
      for (var i = 0; i < alle.length; i++) {
        if (!alle[i].hidden) return alle[i];
      }
      return null;
    };

    var lupeOeffnen = function () {
      var bild = sichtbaresBild();
      if (!bild) return;
      lupeBild.src = bild.dataset.voll || bild.currentSrc || bild.src;
      lupeBild.alt = bild.alt || '';
      buehne.classList.remove('lupe__buehne--zoom');
      buehne.scrollTop = 0;
      buehne.scrollLeft = 0;
      lupe.showModal();
    };

    document.querySelectorAll('[data-lupe-auf]').forEach(function (b) {
      b.addEventListener('click', lupeOeffnen);
    });
    document.querySelectorAll('.galerie__gross img[data-gross]').forEach(function (b) {
      b.addEventListener('click', lupeOeffnen);
    });
    lupe.querySelectorAll('[data-lupe-zu]').forEach(function (b) {
      b.addEventListener('click', function () { lupe.close(); });
    });
    lupeBild.addEventListener('click', function (e) {
      e.stopPropagation();
      var zoomAn = buehne.classList.toggle('lupe__buehne--zoom');
      if (zoomAn) {
        /* Auf den angeklickten Punkt zentrieren, sonst landet man immer oben links. */
        var kasten = lupeBild.getBoundingClientRect();
        var relX = (e.clientX - kasten.left) / kasten.width;
        var relY = (e.clientY - kasten.top) / kasten.height;
        buehne.scrollLeft = relX * buehne.scrollWidth - buehne.clientWidth / 2;
        buehne.scrollTop = relY * buehne.scrollHeight - buehne.clientHeight / 2;
      }
    });
    /* Klick auf die Fläche neben dem Bild schließt. */
    lupe.addEventListener('click', function (e) {
      if (e.target === lupe || e.target === buehne) lupe.close();
    });
  }

  /* ---- Mengenwahl ---- */
  document.querySelectorAll('[data-menge]').forEach(function (feld) {
    var eingabe = feld.querySelector('input');
    feld.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var wert = parseInt(eingabe.value, 10) || 1;
        var neu = b.dataset.schritt === 'plus' ? wert + 1 : wert - 1;
        var max = parseInt(eingabe.max, 10);
        if (neu < 1) neu = 1;
        if (max && neu > max) neu = max;
        eingabe.value = neu;
      });
    });
  });

  /* ---- Versandzusage: nennt den konkreten Werktag ----
     Bis 14 Uhr an einem Werktag geht die Bestellung am selben Tag raus,
     danach am nächsten Werktag. Die Aussage deckt sich mit der FAQ-Seite.
     Die Texte folgen der Seitensprache. Das Datum formatiert der Browser selbst,
     damit Wochentag und Schreibweise je Sprache stimmen; früher standen hier
     feste deutsche Wochentage, die auch auf /fr/ und /it/ ausgegeben wurden. */
  var zusagen = document.querySelectorAll('[data-versandtag]');
  if (zusagen.length) {
    var sprache = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    var WORTE = {
      de: { ab: 'Versand am ', vor: 'Bestellung innerhalb ', nach: ', Versand noch ',
            jetzt: 'heute', std: 'Std.', min: 'Min.' },
      en: { ab: 'Ships on ', vor: 'Order within ', nach: ' and it ships ',
            jetzt: 'today', std: 'h', min: 'min' },
      fr: { ab: 'Expédition ', vor: 'Commandez dans ', nach: " et l'expédition part ",
            jetzt: "aujourd'hui", std: 'h', min: 'min' },
      it: { ab: 'Spedizione ', vor: 'Ordina entro ', nach: ' e la spedizione parte ',
            jetzt: 'oggi', std: 'h', min: 'min' },
      es: { ab: 'Envío el ', vor: 'Pide dentro de ', nach: ' y lo enviamos ',
            jetzt: 'hoy', std: 'h', min: 'min' },
      nl: { ab: 'Verzending op ', vor: 'Bestel binnen ', nach: ' en het wordt ',
            jetzt: 'vandaag', std: 'u', min: 'min' }
    };
    var w = WORTE[sprache] || WORTE.de;
    var werktag = function (d) { return d.getDay() !== 0 && d.getDay() !== 6; };
    var datum = function (d) {
      try {
        return d.toLocaleDateString(sprache, { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        return d.getDate() + '.' + (d.getMonth() + 1) + '.';
      }
    };
    var dauer = function (min) {
      var s = Math.floor(min / 60);
      return (s > 0 ? s + ' ' + w.std + ' ' : '') + (min % 60) + ' ' + w.min;
    };
    var setzen = function () {
      var n = new Date();
      if (!(werktag(n) && n.getHours() < 14)) {
        var ziel = new Date(n);
        do { ziel.setDate(ziel.getDate() + 1); } while (!werktag(ziel));
        zusagen.forEach(function (el) { el.innerHTML = '<b>' + w.ab + datum(ziel) + '</b>'; });
        return;
      }
      var f = new Date(n); f.setHours(14, 0, 0, 0);
      var min = Math.max(0, Math.round((f - n) / 60000));
      zusagen.forEach(function (el) {
        el.innerHTML = w.vor + '<b>' + dauer(min) + '</b>' + w.nach + '<b>' + w.jetzt + '</b>';
      });
    };
    setzen();
    setInterval(setzen, 60000);
  }

  /* ---- Vollbild per Doppelklick auf das Video ----
     Chrome kürzt seine Steuerleiste bei knapper Breite und lässt dabei als Erstes den
     Vollbild-Knopf weg; in eingebetteten Ansichten (Theme-Editor) ist er ausgegraut.
     Der Doppelklick ist deshalb der zweite, immer erreichbare Weg. Klappt die
     Fullscreen-API nicht, legt sich das Video als Ersatz über das ganze Fenster. */
  document.querySelectorAll('.video').forEach(function (figur) {
    var knopf = figur.querySelector('[data-vollbild]');
    var bild = figur.querySelector('video');
    if (knopf && bild) {
      knopf.addEventListener('click', function () {
        bild.dispatchEvent(new Event('dblclick'));
        if (bild.paused) { bild.play().catch(function () {}); }
      });
    }
  });
  document.querySelectorAll('.video video').forEach(function (video) {
    video.addEventListener('dblclick', function () {
      if (document.fullscreenElement || video.classList.contains('video--voll')) {
        if (document.exitFullscreen) { document.exitFullscreen().catch(function () {}); }
        video.classList.remove('video--voll');
        return;
      }
      var starten = video.requestFullscreen || video.webkitRequestFullscreen ||
                    video.webkitEnterFullscreen || video.msRequestFullscreen;
      var geklappt = false;
      if (starten) {
        try { starten.call(video); geklappt = true; } catch (e) { geklappt = false; }
      }
      if (!geklappt && !document.fullscreenEnabled) {
        video.classList.add('video--voll');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.video--voll').forEach(function (v) { v.classList.remove('video--voll'); });
  });

  /* ---- Sortierung der Kollektion ---- */
  document.querySelectorAll('[data-sortierung]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
